import React from 'react';
import { Formula } from '../../interfaces/formula';
import { Grid as ChakraGrid } from '../UI-CHAKRA/Grid';
import { GridItem } from '../UI-CHAKRA/GridItem';
import { Text } from '../UI-CHAKRA/Text';
import { ReactComponent as FormulaIcon } from '../../assets/images/icons/mevo/formula/ic-formula-list.svg';
import { ReactComponent as ThrashIcon } from '../../assets/images/icons/mevo/formula/ic_trash.svg';
import { Flex } from '../UI-CHAKRA/Flex';

interface FormulaSearchItemProps {
  formula: Formula;
  onOpenConfirmDialog(formulaId: number): void;
}

function FormulaSearchItem(props: FormulaSearchItemProps) {
  const formula = props.formula;
  const onOpenConfirmDialog = props.onOpenConfirmDialog;

  return (
    <ChakraGrid
      templateColumns={'repeat(24, 1fr)'}
      width={'100%'}
      whiteSpace={'initial'}
      wordBreak={'break-word'}
      alignItems={'center'}
      h={'full'}
    >
      <GridItem
        colSpan={{ base: 4, md: 2 }}
        justifyContent={'center'}
        h={'100%'}
        alignItems={{ base: 'flex-start', md: 'center' }}
        display={'flex'}
      >
        <FormulaIcon width={'32px'} />
      </GridItem>
      <GridItem
        colSpan={{ base: 18, md: 21 }}
        justifyContent={'flex-start'}
        h={'100%'}
        alignItems={{ base: 'flex-start', md: 'center' }}
        display={'flex'}
      >
        <Flex flexDir={'column'} gap={'4px'}>
          <Text color={'typography.darkest'} fontSize={{ base: 12, md: '14px' }} lineHeight={'16px'}>
            {formula.formulaName}
          </Text>
          <Text color={'#545C62'} fontSize={{ base: 12, md: '12px' }} lineHeight={'16px'}>
            {formula.composition.replaceAll('\n', ', ')}
          </Text>
        </Flex>
      </GridItem>
      <GridItem
        colSpan={{ base: 2, md: 1 }}
        justifyContent={'flex-end'}
        h={'100%'}
        alignItems={{ base: 'flex-start', md: 'center' }}
        display={'flex'}
      >
        <ThrashIcon
          width={'24px'}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onOpenConfirmDialog(formula.id);
          }}
        />
      </GridItem>
    </ChakraGrid>
  );
}

export default React.memo(FormulaSearchItem);
